import React from "react";
import { Link } from "react-router-dom";
import { ChatsCircle, X, ArrowsOut } from "@phosphor-icons/react";
import { TeamChat } from "@/pages/TeamMessages";

export const ChatFab = ({ unread, onOpen }) => (
  <button type="button" onClick={onOpen} title="Team Messages" data-testid="chat-fab"
    className="fixed z-40 right-4 bottom-[calc(1rem+env(safe-area-inset-bottom))] w-14 h-14 rounded-full bg-brand-gold text-brand-navy shadow-lg shadow-black/30 flex items-center justify-center hover:scale-105 active:scale-95 transition-transform">
    <ChatsCircle size={30} weight="fill" />
    {unread && <span className="absolute top-1 right-1 h-3.5 w-3.5 rounded-full bg-red-500 ring-2 ring-white" data-testid="chat-fab-unread" />}
  </button>
);

export const ChatPopup = ({ onClose }) => (
  <div className="fixed inset-0 z-[10000] sm:inset-auto sm:right-4 sm:bottom-4 sm:w-[420px] sm:h-[min(680px,calc(100dvh-6rem))] bg-background sm:border sm:border-border shadow-2xl flex flex-col animate-in fade-in slide-in-from-bottom-4 duration-200" data-testid="chat-popup">
    <div className="bg-brand-navy text-white px-4 h-14 flex items-center gap-2 shrink-0 pt-[env(safe-area-inset-top)] box-content">
      <ChatsCircle size={22} weight="duotone" className="text-brand-gold" />
      <div className="flex-1 font-heading font-semibold">Team Messages</div>
      <Link to="/messages" onClick={onClose} className="p-2 hover:bg-white/10" title="Open full page" data-testid="chat-popup-expand"><ArrowsOut size={18} /></Link>
      <button type="button" onClick={onClose} className="p-2 hover:bg-white/10" title="Close" data-testid="chat-popup-close"><X size={20} /></button>
    </div>
    <div className="flex-1 min-h-0 flex p-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))]">
      <TeamChat header={null} />
    </div>
  </div>
);
